import { useMemo, useState } from 'react';
import { BLOCK_DEFINITIONS } from './blockTypes';

export default function AddBlockPanel({ onAdd, enabledBlockTypes }) {
  const [query, setQuery] = useState('');

  const visibleBlockDefinitions = useMemo(() => {
    // Filter by enabled types first (handle both Set and Array)
    let filtered = BLOCK_DEFINITIONS;
    if (enabledBlockTypes && enabledBlockTypes.size > 0) {
      filtered = BLOCK_DEFINITIONS.filter(def => enabledBlockTypes.has(def.type));
    } else if (Array.isArray(enabledBlockTypes) && enabledBlockTypes.length > 0) {
      filtered = BLOCK_DEFINITIONS.filter(def => enabledBlockTypes.includes(def.type));
    }

    // Sort alphabetically
    const sorted = [...filtered].sort((a, b) =>
      String(a?.label || '').localeCompare(String(b?.label || ''), undefined, { sensitivity: 'base' })
    );

    // Apply search filter
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) return sorted;

    return sorted.filter((def) => {
      const label = String(def?.label || '').toLowerCase();
      const type = String(def?.type || '').toLowerCase();
      return label.includes(normalizedQuery) || type.includes(normalizedQuery);
    });
  }, [query, enabledBlockTypes]);

  return (
    <div className="pagebuilder-add-panel">
      <p className="pagebuilder-add-panel-label">Choose a block type to add:</p>
      <input
        type="search"
        className="pagebuilder-add-search"
        placeholder="Search block types"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        aria-label="Search block types"
      />
      <div className="pagebuilder-type-grid">
        {visibleBlockDefinitions.map((def) => (
          <button
            key={def.type}
            type="button"
            className="pagebuilder-type-btn"
            onClick={() => onAdd(def.type)}
          >
            <i className={`${def.icon} pagebuilder-type-icon`} aria-hidden="true" />
            <span>{def.label}</span>
          </button>
        ))}
      </div>
      {visibleBlockDefinitions.length === 0 && (
        <p className="pagebuilder-add-empty">No block types match your search.</p>
      )}
    </div>
  );
}
